import DOMPurify from 'dompurify';

// Links keep opening in a new tab, so an editor does not lose a reply they are writing; the new tab gets no access to this one.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.hasAttribute('target')) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

/** HTML from outside the CMS (RSS items, tip replies) cleaned before v-html, so no script or event handler runs in an editor's session. */
export const safeHtml = (html: string | null | undefined): string => DOMPurify.sanitize(html ?? '', { USE_PROFILES: { html: true }, ADD_ATTR: ['target'] });

/** Only http(s) links, so a feed cannot hand us a javascript: URL. */
export const safeUrl = (url: string | null | undefined): string => (url && /^https?:\/\//i.test(url) ? url : '#');
